import React, { useState } from 'react'
import useApi from 'hooks/useApi'
import {
  Modal,
  Button,
  DataTable,
  Icon
} from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

import {
  Paragraph,
  Timestamp,
  FileMeta,
  FilePreview,
} from 'components/datatable'

export default NiceModal.create(({ order, task }) => {
  const [orderFiles] = useApi(`/rest/v1/order/${order.uid}/files`)
  const [selectedFileIds, setSelectedFileIds] = useState([])
  const [loading, setLoading] = useState(false)

  const modal = useModal()

  const onSubmit = () => {
    setLoading(true)

    const promises = selectedFileIds.map((id) => (
      fetch(`/ordertask/addExistingFileToTask?fileId=${id}&taskId=${task.uid}`, { method: 'POST' })
    ))

    Promise.all(promises).then(() => {
      modal.resolve({ selectedFileIds })
      modal.remove()
    })
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => (!selectedFileIds.length || loading) ? undefined : onSubmit()}
      dialogPanelClasses="max-w-4xl overflow-x-scroll"
    >
      <div className="space-y-10">
        <p>Selected files will be duplicated and attached to task #{ task.uid}.</p>

        <DataTable
          className="border border-gray-100 table-fixed"
          rowSelectionKey="uid"
          rowsSelected={selectedFileIds}
          onRowSelected={(key) => {
            if (selectedFileIds.includes(key)) {
              setSelectedFileIds((prev) => prev.filter((id) => id !== key))
            } else {
              setSelectedFileIds((prev) => [...prev, key])
            }
          }}
          indicators={[
            (file) => (
              <Icon
                onClick={() => window.open(file.url, '_blank')}
                className='text-xs cursor-pointer text-primary px-4'
                icon={['fal', 'download']}
              />
            ),
          ]}
          head={{
            title: { className: 'w-4/12', label: 'Audio' },
            cdn_url: { className: 'w-2/12', label: 'Preview' },
            tstamp: { className: 'w-2/12', label: 'Uploaded at' },
            duration: { className: 'w-2/12', label: 'Meta' },
          }}
          body={{
            title: (entry) => <Paragraph title={entry.title} className="truncate">{entry.title}</Paragraph>,
            cdn_url: FilePreview,
            tstamp: Timestamp,
            duration: FileMeta,
          }}
          entries={orderFiles}
        />

        <Button
          size="sm"
          disabled={!selectedFileIds.length || loading}
          onClick={onSubmit}
        >
          { loading ? 'Loading..' : 'Duplicate to task' }
        </Button>
      </div>
    </Modal>
  )
})
